<template>

  <Contabili />

</template>

<script>
import Contabili from '../components/pratiche/Contabili.vue'

export default {
  pageName: 'Contabili',
  components: {
    Contabili

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
